import { render, staticRenderFns } from "./AccountingGateway.vue?vue&type=template&id=020b3018&scoped=true&"
import script from "./AccountingGateway.vue?vue&type=script&lang=js&"
export * from "./AccountingGateway.vue?vue&type=script&lang=js&"
import style0 from "./AccountingGateway.vue?vue&type=style&index=0&id=020b3018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020b3018",
  null
  
)

export default component.exports